/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component, Fragment } from "react";

class ToolsBoardWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToolsBoardLoaded: false
    };
    this._init();
  }

  _init() {
    this.ToolsBoard = null;
    this._loadToolsBoardDropin();
  }

  async _loadToolsBoardDropin() {
    if (this.state.isToolsBoardLoaded === false) {
      this.ToolsBoard = await this.props.getToolsBoardComponent();
      this._setToolsBoard();
    }
  }

  _setToolsBoard() {
    this.setState({
      isToolsBoardLoaded: true
    });
  }

  render() {
    return (
      <Fragment>
        {this.state.isToolsBoardLoaded ? (
          <this.ToolsBoard
            connectorType={this.props.connectorType}
            shouldUseMobileModernViewer
            getViewerAnalyticsForKey={this.props.getViewerAnalyticsForKey}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default ToolsBoardWrapper;
